export const links = {
  about: '/about',
  onlineTuition: '/online-tuition',
  programmes: '/programmes',
  contact: '/contact',
  aLevelsComputing: '/a-levels-computing',
  oLevelsComputing: '/o-levels-computing',
  ibComputing: '/ib-computing',
  igcseComputing: '/igcse-computing',
  internationalSchools: '/international-schools',
}
